import 'arrive';

document.arrive('.block-banner', { existing: true }, function (block) {
    const content = block.querySelector('.block-banner__content');
    if (!content) return;

    content.style.willChange = 'transform';
    content.style.transition = 'none'; 
    
    const speed = 0.35;

    function updateParallax(y) {
        const blockTop = block.offsetTop;
        const scrollTop = y;
        const relativeScroll = scrollTop - blockTop;

        // INVERSIONE: Aggiungiamo il segno meno davanti
        // Se prima scendeva, ora salirà rispetto al banner (e viceversa)
        const translateY = -(relativeScroll * speed);
        
        content.style.transform = `translate3d(0, ${translateY}px, 0)`;
    }

    if (window.lenis) {
        window.lenis.on('scroll', (e) => updateParallax(e.scroll));
        updateParallax(window.lenis.scroll);
    } else {
        window.addEventListener('scroll', () => updateParallax(window.scrollY), { passive: true });
    }
});